const localeCache = new Map();

function getFormatter(locale, options) {
  const key = `${locale}::${JSON.stringify(options || {})}`;
  if (!localeCache.has(key)) {
    localeCache.set(key, new Intl.NumberFormat(locale, options));
  }
  return localeCache.get(key);
}

function getLocale() {
  return navigator?.language || 'es';
}

export function getLocaleSeparators() {
  const parts = getFormatter(getLocale()).formatToParts(1111.1);
  return {
    groupSeparator: parts.find((p) => p.type === 'group')?.value || ',',
    decimalSeparator: parts.find((p) => p.type === 'decimal')?.value || '.',
  };
}

export function formatNumberLocale(value, decimals) {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return '';

  const locale = getLocale();

  if (typeof decimals === 'number') {
    const d = Math.min(20, Math.max(0, Math.trunc(decimals)));
    return getFormatter(locale, {
      minimumFractionDigits: d,
      maximumFractionDigits: d,
    }).format(num);
  }

  return getFormatter(locale, { maximumFractionDigits: 20 }).format(num);
}

export function formatNumberLocaleRaw(value, decimals) {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return '';

  const { groupSeparator, decimalSeparator } = getLocaleSeparators();
  const raw = num.toFixed(decimals);
  const [intPart, decPart] = raw.split('.');
  const groupedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
  return decPart !== undefined ? `${groupedInt}${decimalSeparator}${decPart}` : groupedInt;
}

export function formatCurrencyLocale(value, currency = 'ARS', minimumFractionDigits = 0) {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (isNaN(num)) return '';

  return getFormatter(getLocale(), {
    style: 'currency',
    currency,
    minimumFractionDigits,
  }).format(num);
}

export function parseNumberLocale(value) {
  if (value === null || value === undefined || value === '') return undefined;
  const { groupSeparator, decimalSeparator } = getLocaleSeparators();
  let str = String(value);

  if (str.endsWith(decimalSeparator) || str.endsWith('.')) {
    const beforeSep = str.slice(0, -1).split(groupSeparator).join('');
    const cleaned = beforeSep.replace(/[^\d.-]/g, '');
    const num = parseFloat(cleaned);
    if (!isNaN(num)) return `${String(num)}${decimalSeparator}`;
    return decimalSeparator;
  }

  if (str.includes(decimalSeparator)) {
    const [beforeDecimal, ...afterParts] = str.split(decimalSeparator);
    const cleanedBefore = beforeDecimal.split(groupSeparator).join('');
    str = `${cleanedBefore}.${afterParts.join('')}`;
  } else {
    str = str.split(groupSeparator).join('');
  }

  str = str.replace(/[^\d.-]/g, '');
  const num = parseFloat(str);
  return isNaN(num) ? undefined : num;
}
